import React from 'react'

import { Text } from '../../../components/presentation/Text'
import Link from '../../../components/actions/Link'
import LoginTemplate from '../_template/LoginTemplate'
import NewPasswordForm from './NewPasswordForm'
import { COLORS } from '@btime/constants'

const NewPasswordPage = () => {
  return (
    <LoginTemplate
      footer={
        <Link to="/m">
          <Text color={COLORS.dark3}>
            Lembrou da sua senha? <span style={{ color: COLORS.purple }}>Clique aqui</span>
          </Text>
        </Link>
      }
    >
      <NewPasswordForm />
    </LoginTemplate>
  )
}

export default NewPasswordPage
